var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9 1.35C0.9 1.10147 1.10147 0.9 1.35 0.9H5.175H6.525C6.77353 0.9 6.975 0.698528 6.975 0.45C6.975 0.201472 6.77353 0 6.525 0H5.175H1.35C0.604415 0 0 0.604416 0 1.35V7.425C0 7.67353 0.201472 7.875 0.45 7.875C0.698528 7.875 0.9 7.67353 0.9 7.425V1.35ZM4.95 1.8C4.83065 1.8 4.71619 1.84741 4.6318 1.9318L1.9318 4.6318C1.84741 4.71619 1.8 4.83065 1.8 4.95V7.85C1.8 8.48513 2.31487 9 2.95 9H7.85C8.48513 9 9 8.48513 9 7.85V2.95C9 2.31487 8.48513 1.8 7.85 1.8H4.95ZM5.4 2.7H7.85C7.98807 2.7 8.1 2.81193 8.1 2.95V7.85C8.1 7.98807 7.98807 8.1 7.85 8.1H2.95C2.81193 8.1 2.7 7.98807 2.7 7.85V5.4H4.95C5.19853 5.4 5.4 5.19853 5.4 4.95V2.7ZM4.5 4.5H3.3364L4.5 3.3364V4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.2bd00df7657385d4be54ebcbe20c0b3f.svg";
export { ForwardRef as ReactComponent };